export const GUEST = 'guest';
export const SECURED = 'secured';
export const FIRST = 'first';
export const PUBLIC = 'public';